import { RespondentType } from '../models/questions';
import { isApplePayAvailableAsPaymentMethod } from '../selectors/order';
import { CheckoutState } from '../state';
import { isApplePaySupported } from '../utils/applePay';
import { isEventbriteTLDInDevOrQAEnv, isIosApp } from '../utils/browser';
import { ENABLE_APPLE_PAY } from '../utils/splitio';
import { getSurveyType, isEventbriteTLD } from './app';
import {
    getIsFreeEvent,
    getIsReservedSeating,
    hasRequiredCannedQuestions,
    hasRequiredCustomQuestions,
} from './event';
import { isSplitTreatmentEnabled } from './splitio';
import { isUserLoggedIn } from './user';

export const isTLDWithApplePayEnabled = (state: CheckoutState) =>
    isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv() || isIosApp(state);

export const isApplePayInCheckoutStepEnabled = (state: CheckoutState) =>
    isApplePayAvailableAsPaymentMethod(state) &&
    isTLDWithApplePayEnabled(state) &&
    isSplitTreatmentEnabled(state, ENABLE_APPLE_PAY) &&
    isApplePaySupported();

export const getCanMakePaymentsWithActiveCard = (state: CheckoutState) =>
    state.applepay?.canMakePaymentsWithActiveCard;

export const isApplePaySortedAndPreselected = (state: CheckoutState) =>
    !!getCanMakePaymentsWithActiveCard(state);

export const getApplePayInstance = (state: CheckoutState) =>
    state.applepay?.applepayInstance;

export const hasExpressCheckoutAsyncErrors = (state: CheckoutState) =>
    state.applepay?.hasAsyncErrors;

export const isApplePayInstanceCreated = (state: CheckoutState) =>
    !!getApplePayInstance(state);

export const areSyncExpressCheckoutEligibleRulesMet = (state: CheckoutState) =>
    isUserLoggedIn(state) && // TODO: Remove this condition once all the new endpoints allow anonymous traffic
    isTLDWithApplePayEnabled(state) &&
    isApplePaySupported() &&
    !getIsFreeEvent(state) &&
    !getIsReservedSeating(state) &&
    (getSurveyType(state) === RespondentType.buyer ||
        getSurveyType(state) === RespondentType.direct);

export const areAsyncExpressCheckoutEligibleRulesMet = (state: CheckoutState) =>
    !hasRequiredCannedQuestions(state) &&
    !hasRequiredCustomQuestions(state) &&
    // !hasSpecialInstructions(state) && TODO: Enable this line once the special instructions API returns data for anonymous traffic
    isApplePayAvailableAsPaymentMethod(state) &&
    !hasExpressCheckoutAsyncErrors(state);

export const getApplePay = (state: CheckoutState) => state.applepay;
